import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation SessionCreateMutation($input: Session__CreateInput!) {
    sessionCreate(input: $input) {
      error
      token
      user {
        id
        dbId
        firstName
        lastName
        email
        paymentAccountStripeUid
        bookAllowance
        program {
          name
        }
      }
    }
  }
`;

const commit = input =>
  createMutation({
    mutation,

    variables: {
      input
    }
  });

export default { commit };
